import { ROLES } from './roles';

export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard.view',
  ONBOARDING_VIEW: 'onboarding.view',
  ONBOARDING_MANAGE: 'onboarding.manage',

  SUPPORT_VIEW: 'support.view',
  SUPPORT_MANAGE: 'support.manage',
  CONTACT_INQUIRIES_VIEW: 'contactInquiries.view',
  CONTACT_INQUIRIES_MANAGE: 'contactInquiries.manage',
  SETTINGS_VIEW: 'settings.view',
  SETTINGS_PROFILE_EDIT: 'settings.profile.edit',
  SETTINGS_SECURITY_EDIT: 'settings.security.edit',
  SETTINGS_PREFERENCES_EDIT: 'settings.preferences.edit',
  SETTINGS_NOTIFICATIONS_EDIT: 'settings.notifications.edit',
  SETTINGS_SOCIETY_VIEW: 'settings.society.view',
  SETTINGS_SOCIETY_EDIT: 'settings.society.edit',
  SETTINGS_TEAM_VIEW: 'settings.team.view',
  SETTINGS_TEAM_MANAGE: 'settings.team.manage',
  SETTINGS_OPERATIONS_VIEW: 'settings.operations.view',
  SETTINGS_OPERATIONS_EDIT: 'settings.operations.edit',
  SETTINGS_SOCIETY_OPERATIONS_VIEW: 'settings.societyOperations.view',
  SETTINGS_SOCIETY_OPERATIONS_EDIT: 'settings.societyOperations.edit',
  SETTINGS_GUARD_POLICY_VIEW: 'settings.guardPolicy.view',
  SETTINGS_GUARD_POLICY_EDIT: 'settings.guardPolicy.edit',
  OPERATION_BLOCKS_VIEW: 'operationBlocks.view',
  OPERATION_BLOCKS_MANAGE: 'operationBlocks.manage',
  APP_VERSION_POLICIES_VIEW: 'appVersionPolicies.view',
  APP_VERSION_POLICIES_MANAGE: 'appVersionPolicies.manage',
  SETTINGS_PLATFORM_VIEW: 'settings.platform.view',
  SETTINGS_PLATFORM_EDIT: 'settings.platform.edit',
  SUPPORT_TICKET_DIGEST_VIEW: 'platform.settings.supportTicketDigest.read',
  SUPPORT_TICKET_DIGEST_EDIT: 'platform.settings.supportTicketDigest.update',
  MANAGERS_VIEW: 'managers.view',
  MANAGERS_MANAGE: 'managers.manage',

  LOGS_VIEW: 'logs.view',
  LOGS_EXPORT: 'logs.export',
  AUDIT_LOGS_VIEW: 'auditLogs.view',

  USERS_VIEW: 'users.view',
  USERS_EXPORT: 'users.export',
  USERS_MANAGE: 'users.manage',
  VEHICLES_EXPORT: 'vehicles.export',

  INVENTORY_SOCIETY_VIEW: 'inventory.society.view',
  INVENTORY_SOCIETY_MANAGE: 'inventory.society.manage',

  INVENTORY_GLOBAL_VIEW: 'inventory.global.view',
  INVENTORY_GLOBAL_MANAGE: 'inventory.global.manage',

  CONTROLLERS_VIEW: 'controllers.view',
  CONTROLLERS_MANAGE: 'controllers.manage',
  CONTROLLER_COMMAND_DIAGNOSTICS: 'controller.command.diagnostics',
  CONTROLLER_COMMAND_LOGS: 'controller.command.logs',
  CONTROLLER_COMMAND_RESTART: 'controller.command.restart',
  CONTROLLER_COMMAND_ANPR_RESTART: 'controller.command.anpr.restart',
  CONTROLLER_COMMAND_GATE_DISABLE: 'controller.command.gate.disable',
  CONTROLLER_COMMAND_GATE_ENABLE: 'controller.command.gate.enable',
  CONTROLLER_COMMAND_DEPLOY: 'controller.command.deploy',
  CONTROLLER_COMMAND_ROLLBACK: 'controller.command.rollback',
  CONTROLLER_COMMAND_REBOOT: 'controller.command.reboot',
  ADMIN_APPROVAL_REQUEST: 'platform.adminApprovals.request',
  ADMIN_APPROVAL_READ: 'platform.adminApprovals.read',
  ADMIN_APPROVAL_APPROVE: 'platform.adminApprovals.approve',
  REMOTE_ACCESS_SSH: 'controller.remoteAccess.ssh',
  REMOTE_ACCESS_SESSION_ADMIN: 'controller.remoteAccess.sessionAdmin',

  SOCIETIES_VIEW: 'societies.view',
  SOCIETIES_MANAGE: 'societies.manage',
  SOCIETY_ADMINS_MANAGE: 'societyAdmins.manage',
};

export const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.ONBOARDING_VIEW,
    PERMISSIONS.ONBOARDING_MANAGE,
    PERMISSIONS.SUPPORT_VIEW,
    PERMISSIONS.SUPPORT_MANAGE,
    PERMISSIONS.CONTACT_INQUIRIES_VIEW,
    PERMISSIONS.CONTACT_INQUIRIES_MANAGE,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
    PERMISSIONS.SETTINGS_PREFERENCES_EDIT,
    PERMISSIONS.SETTINGS_NOTIFICATIONS_EDIT,
    PERMISSIONS.SETTINGS_SOCIETY_VIEW,
    PERMISSIONS.SETTINGS_SOCIETY_EDIT,
    PERMISSIONS.SETTINGS_TEAM_VIEW,
    PERMISSIONS.SETTINGS_TEAM_MANAGE,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_VIEW,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_EDIT,
    PERMISSIONS.SETTINGS_GUARD_POLICY_VIEW,
    PERMISSIONS.SETTINGS_GUARD_POLICY_EDIT,
    PERMISSIONS.OPERATION_BLOCKS_VIEW,
    PERMISSIONS.OPERATION_BLOCKS_MANAGE,
    PERMISSIONS.APP_VERSION_POLICIES_VIEW,
    PERMISSIONS.APP_VERSION_POLICIES_MANAGE,
    PERMISSIONS.SETTINGS_PLATFORM_VIEW,
    PERMISSIONS.SETTINGS_PLATFORM_EDIT,
    PERMISSIONS.SUPPORT_TICKET_DIGEST_VIEW,
    PERMISSIONS.SUPPORT_TICKET_DIGEST_EDIT,
    PERMISSIONS.LOGS_VIEW,
    PERMISSIONS.LOGS_EXPORT,
    PERMISSIONS.AUDIT_LOGS_VIEW,
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_EXPORT,
    PERMISSIONS.USERS_MANAGE,
    PERMISSIONS.VEHICLES_EXPORT,
    PERMISSIONS.INVENTORY_SOCIETY_VIEW,
    PERMISSIONS.INVENTORY_SOCIETY_MANAGE,
    PERMISSIONS.INVENTORY_GLOBAL_VIEW,
    PERMISSIONS.INVENTORY_GLOBAL_MANAGE,
    PERMISSIONS.CONTROLLERS_VIEW,
    PERMISSIONS.CONTROLLERS_MANAGE,
    PERMISSIONS.CONTROLLER_COMMAND_DIAGNOSTICS,
    PERMISSIONS.CONTROLLER_COMMAND_LOGS,
    PERMISSIONS.CONTROLLER_COMMAND_RESTART,
    PERMISSIONS.CONTROLLER_COMMAND_ANPR_RESTART,
    PERMISSIONS.CONTROLLER_COMMAND_GATE_DISABLE,
    PERMISSIONS.CONTROLLER_COMMAND_GATE_ENABLE,
    PERMISSIONS.CONTROLLER_COMMAND_DEPLOY,
    PERMISSIONS.CONTROLLER_COMMAND_ROLLBACK,
    PERMISSIONS.CONTROLLER_COMMAND_REBOOT,
    PERMISSIONS.ADMIN_APPROVAL_REQUEST,
    PERMISSIONS.ADMIN_APPROVAL_READ,
    PERMISSIONS.ADMIN_APPROVAL_APPROVE,
    PERMISSIONS.REMOTE_ACCESS_SSH,
    PERMISSIONS.REMOTE_ACCESS_SESSION_ADMIN,
    PERMISSIONS.SOCIETIES_VIEW,
    PERMISSIONS.SOCIETIES_MANAGE,
    PERMISSIONS.SOCIETY_ADMINS_MANAGE,
  ],
  [ROLES.SOCIETY_ADMIN]: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.SUPPORT_VIEW,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
    PERMISSIONS.SETTINGS_PREFERENCES_EDIT,
    PERMISSIONS.SETTINGS_NOTIFICATIONS_EDIT,
    PERMISSIONS.SETTINGS_TEAM_VIEW,
    PERMISSIONS.SETTINGS_TEAM_MANAGE,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_VIEW,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_EDIT,
    PERMISSIONS.SETTINGS_GUARD_POLICY_VIEW,
    PERMISSIONS.SETTINGS_GUARD_POLICY_EDIT,
    PERMISSIONS.MANAGERS_VIEW,
    PERMISSIONS.MANAGERS_MANAGE,
    PERMISSIONS.LOGS_VIEW,
    PERMISSIONS.LOGS_EXPORT,
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_EXPORT,
    PERMISSIONS.USERS_MANAGE,
    PERMISSIONS.VEHICLES_EXPORT,
    PERMISSIONS.INVENTORY_SOCIETY_VIEW,
    PERMISSIONS.INVENTORY_SOCIETY_MANAGE,
    PERMISSIONS.CONTROLLERS_VIEW,
  ],
  [ROLES.SOCIETY_MANAGER]: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.SUPPORT_VIEW,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
    PERMISSIONS.SETTINGS_PREFERENCES_EDIT,
    PERMISSIONS.SETTINGS_NOTIFICATIONS_EDIT,
    PERMISSIONS.SETTINGS_TEAM_VIEW,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_VIEW,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_EDIT,
    PERMISSIONS.SETTINGS_GUARD_POLICY_VIEW,
    PERMISSIONS.MANAGERS_VIEW,
    PERMISSIONS.LOGS_VIEW,
    PERMISSIONS.LOGS_EXPORT,
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_EXPORT,
    PERMISSIONS.USERS_MANAGE,
    PERMISSIONS.VEHICLES_EXPORT,
    PERMISSIONS.INVENTORY_SOCIETY_VIEW,
    PERMISSIONS.INVENTORY_SOCIETY_MANAGE,
    PERMISSIONS.CONTROLLERS_VIEW,
  ],
  [ROLES.DEVELOPER]: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.ONBOARDING_VIEW,
    PERMISSIONS.ONBOARDING_MANAGE,
    PERMISSIONS.SUPPORT_VIEW,
    PERMISSIONS.SUPPORT_MANAGE,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
    PERMISSIONS.SETTINGS_PREFERENCES_EDIT,
    PERMISSIONS.SETTINGS_NOTIFICATIONS_EDIT,
    PERMISSIONS.SETTINGS_TEAM_VIEW,
    PERMISSIONS.SETTINGS_TEAM_MANAGE,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_VIEW,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_EDIT,
    PERMISSIONS.SETTINGS_GUARD_POLICY_VIEW,
    PERMISSIONS.SETTINGS_GUARD_POLICY_EDIT,
    PERMISSIONS.OPERATION_BLOCKS_VIEW,
    PERMISSIONS.OPERATION_BLOCKS_MANAGE,
    PERMISSIONS.APP_VERSION_POLICIES_VIEW,
    PERMISSIONS.APP_VERSION_POLICIES_MANAGE,
    PERMISSIONS.SETTINGS_PLATFORM_VIEW,
    PERMISSIONS.SETTINGS_PLATFORM_EDIT,
    PERMISSIONS.SUPPORT_TICKET_DIGEST_VIEW,
    PERMISSIONS.SUPPORT_TICKET_DIGEST_EDIT,
    PERMISSIONS.LOGS_VIEW,
    PERMISSIONS.LOGS_EXPORT,
    PERMISSIONS.AUDIT_LOGS_VIEW,
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_EXPORT,
    PERMISSIONS.USERS_MANAGE,
    PERMISSIONS.VEHICLES_EXPORT,
    PERMISSIONS.INVENTORY_SOCIETY_VIEW,
    PERMISSIONS.INVENTORY_SOCIETY_MANAGE,
    PERMISSIONS.INVENTORY_GLOBAL_VIEW,
    PERMISSIONS.INVENTORY_GLOBAL_MANAGE,
    PERMISSIONS.CONTROLLERS_VIEW,
    PERMISSIONS.CONTROLLERS_MANAGE,
    PERMISSIONS.CONTROLLER_COMMAND_DIAGNOSTICS,
    PERMISSIONS.CONTROLLER_COMMAND_LOGS,
    PERMISSIONS.CONTROLLER_COMMAND_RESTART,
    PERMISSIONS.CONTROLLER_COMMAND_ANPR_RESTART,
    PERMISSIONS.CONTROLLER_COMMAND_GATE_DISABLE,
    PERMISSIONS.CONTROLLER_COMMAND_GATE_ENABLE,
    PERMISSIONS.CONTROLLER_COMMAND_DEPLOY,
    PERMISSIONS.CONTROLLER_COMMAND_ROLLBACK,
    PERMISSIONS.CONTROLLER_COMMAND_REBOOT,
    PERMISSIONS.ADMIN_APPROVAL_REQUEST,
    PERMISSIONS.ADMIN_APPROVAL_READ,
    PERMISSIONS.REMOTE_ACCESS_SSH,
    PERMISSIONS.REMOTE_ACCESS_SESSION_ADMIN,
    PERMISSIONS.SOCIETIES_VIEW,
    PERMISSIONS.SOCIETIES_MANAGE,
    PERMISSIONS.SOCIETY_ADMINS_MANAGE,
  ],
  [ROLES.ACCOUNT_MANAGER]: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.ONBOARDING_VIEW,
    PERMISSIONS.ONBOARDING_MANAGE,
    PERMISSIONS.SUPPORT_VIEW,
    PERMISSIONS.SUPPORT_MANAGE,
    PERMISSIONS.CONTACT_INQUIRIES_VIEW,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
    PERMISSIONS.SETTINGS_PREFERENCES_EDIT,
    PERMISSIONS.SETTINGS_NOTIFICATIONS_EDIT,
    PERMISSIONS.SETTINGS_TEAM_VIEW,
    PERMISSIONS.SETTINGS_TEAM_MANAGE,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_VIEW,
    PERMISSIONS.SETTINGS_SOCIETY_OPERATIONS_EDIT,
    PERMISSIONS.SETTINGS_GUARD_POLICY_VIEW,
    PERMISSIONS.SETTINGS_GUARD_POLICY_EDIT,
    PERMISSIONS.SUPPORT_TICKET_DIGEST_VIEW,
    PERMISSIONS.SUPPORT_TICKET_DIGEST_EDIT,
    PERMISSIONS.LOGS_VIEW,
    PERMISSIONS.LOGS_EXPORT,
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_EXPORT,
    PERMISSIONS.USERS_MANAGE,
    PERMISSIONS.VEHICLES_EXPORT,
    PERMISSIONS.INVENTORY_SOCIETY_VIEW,
    PERMISSIONS.INVENTORY_SOCIETY_MANAGE,
    PERMISSIONS.INVENTORY_GLOBAL_VIEW,
    PERMISSIONS.INVENTORY_GLOBAL_MANAGE,
    PERMISSIONS.CONTROLLERS_VIEW,
    PERMISSIONS.SOCIETIES_VIEW,
  ],
  [ROLES.SOCIETY_GUARD]: [
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
    PERMISSIONS.SETTINGS_PREFERENCES_EDIT,
    PERMISSIONS.SETTINGS_NOTIFICATIONS_EDIT,
    PERMISSIONS.SETTINGS_GUARD_POLICY_VIEW,
    PERMISSIONS.LOGS_VIEW,
    PERMISSIONS.CONTROLLERS_VIEW,
  ],
  [ROLES.SUPPORT_AGENT]: [
    PERMISSIONS.SUPPORT_VIEW,
    PERMISSIONS.SUPPORT_MANAGE,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
  ],
  [ROLES.SUPPORT_MANAGER]: [
    PERMISSIONS.SUPPORT_VIEW,
    PERMISSIONS.SUPPORT_MANAGE,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
  ],
  [ROLES.TECHNICIAN]: [
    PERMISSIONS.SUPPORT_VIEW,
    PERMISSIONS.SUPPORT_MANAGE,
    PERMISSIONS.CONTROLLERS_VIEW,
    PERMISSIONS.CONTROLLERS_MANAGE,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
  ],
  [ROLES.INSTALLATION_MANAGER]: [
    PERMISSIONS.CONTROLLERS_VIEW,
    PERMISSIONS.CONTROLLERS_MANAGE,
    PERMISSIONS.CONTROLLER_COMMAND_DIAGNOSTICS,
    PERMISSIONS.CONTROLLER_COMMAND_LOGS,
    PERMISSIONS.CONTROLLER_COMMAND_RESTART,
    PERMISSIONS.CONTROLLER_COMMAND_ANPR_RESTART,
    PERMISSIONS.CONTROLLER_COMMAND_GATE_ENABLE,
    PERMISSIONS.REMOTE_ACCESS_SSH,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
  ],
  [ROLES.AUDITOR]: [
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SETTINGS_PROFILE_EDIT,
    PERMISSIONS.SETTINGS_SECURITY_EDIT,
  ],
};
